export default "__VITE_ASSET__CEoZVIJD__"